/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InviteFoodicsUsersRequest
 */
export interface InviteFoodicsUsersRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InviteFoodicsUsersRequest
     */
    ids: Array<string>;
}

/**
 * Check if a given object implements the InviteFoodicsUsersRequest interface.
 */
export function instanceOfInviteFoodicsUsersRequest(value: object): value is InviteFoodicsUsersRequest {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    return true;
}

export function InviteFoodicsUsersRequestFromJSON(json: any): InviteFoodicsUsersRequest {
    return InviteFoodicsUsersRequestFromJSONTyped(json, false);
}

export function InviteFoodicsUsersRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InviteFoodicsUsersRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
    };
}

export function InviteFoodicsUsersRequestToJSON(json: any): InviteFoodicsUsersRequest {
    return InviteFoodicsUsersRequestToJSONTyped(json, false);
}

export function InviteFoodicsUsersRequestToJSONTyped(value?: InviteFoodicsUsersRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
    };
}

